import { type FC, memo, useMemo } from 'react';

import type { Props } from '@/components/select/JurisdictionSelect/types';
import useJurisdictions from '@/hooks/useJurisdictions';
import { Select } from '@/ui';

const JurisdictionSelect: FC<Props> = (props) => {
  const { data: jurisdictions, isLoading } = useJurisdictions();

  const options = useMemo(
    () =>
      (jurisdictions ?? []).map((jurisdiction) => ({
        label: jurisdiction.name,
        value: jurisdiction.id
      })),
    [jurisdictions]
  );

  const sharedProps = {
    label: 'Jurisdiction',
    ariaLabel: 'Jurisdiction',
    options,
    disabled: props.disabled || isLoading
  };

  if (props.multiple) {
    const selectedOptions = options.filter((option) =>
      props.selectedJurisdictionIds.includes(option.value)
    );

    return (
      <Select
        {...sharedProps}
        multiple
        selectedOptions={selectedOptions}
        onChange={(next) => props.onChange(next.map((option) => option.value))}
        placeholder="Select jurisdictions..."
      />
    );
  }

  const selectedOption =
    options.find((option) => option.value === props.selectedJurisdictionId) ?? null;

  return (
    <Select
      {...sharedProps}
      selectedOption={selectedOption}
      onChange={(next) => props.onChange(next?.value ?? null)}
      placeholder="Select jurisdiction..."
    />
  );
};

export default memo(JurisdictionSelect);
